import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NotifState {
  pendingMismatchRequests: number;
  setPendingMismatchRequests: (pendingMismatchRequests: number) => void;
  showNotification: boolean;
  setShowNotification: (showNotification: boolean) => void;
}

const initialState = {
  pendingMismatchRequests: 0,
  showNotification: false,
};

export const useNotifState = create<NotifState>()(
  persist(
    (set, get) => ({
      ...initialState,
      setPendingMismatchRequests: (pendingMismatchRequests: number) => {
        const curr = get();

        set({
          pendingMismatchRequests,
          showNotification:
            pendingMismatchRequests > curr.pendingMismatchRequests,
        });
      },
      setShowNotification: (showNotification: boolean) =>
        set({ showNotification }),
    }),
    {
      name: 'notifs-storage',
    }
  )
);
